<template>
    <div>
        <div class="user_right">
            <div class="bt_rd">
                <a href="javascript:;" class="av_ama">
                    <img :src="userInfo.avatar" class="av_img" width="80" height="80">
                </a>
                <table width="100%" cellpadding="0" class="ub_tbs lh30">
                    <tbody>
                        <tr>
                            <td><h2 class="us_h2">{{userInfo.username}}【{{userInfo.nickname}}】</h2></td>
                            <td>绑定手机：{{userInfo.tel}}<b class="i_new f12" style="margin-left:10px;">已验证</b></td>
                        </tr>
                        <tr>
                            <td>会员等级：<b style="padding: 3px 6px; background: #f00180; border-radius: 5px; color: #ffffff; margin-left: 10px;">{{userInfo.rating_name}}</b></td>
                            <td>积分：{{$fnc.toFixedZ(userInfo.integral,2) }}</td>
                        </tr>
                        <tr>
                            <td>余额：{{$fnc.toFixedZ(userInfo.money,2) }}<b style="padding: 3px 6px; background: #f00180; border-radius: 5px; color: #ffffff; margin-left: 10px;">提现</b></td>
                            <td>佣金：{{$fnc.toFixedZ(userInfo.amount,2) }}</td>
                        </tr>
                        <tr>
                            <td><a class="org f12" href="javascript:;" @click="$router.push({path: '/user_profile'})">修改个人信息</a></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="av_odf">
                <a href="javascript:;" @click="$router.push({path: '/weifukuan', query:{status:'未支付',showVideo:1,}})" class="av_oa">
                    <img src="https://s.cccgx.com/themes/v4/css/u/o1.png" class="av_tck">
                    <p>待付款</p>
                </a>
                <a href="javascript:;" @click="$router.push({path: '/weifahuo', query:{status:'已支付',showVideo:1,}})" class="av_oa">
                    <img src="https://s.cccgx.com/themes/v4/css/u/o2.png" class="av_tck">
                    <p>待发货</p>
                </a>
                <a href="javascript:;" @click="$router.push({path: '/weishouhuo', query:{status:'已发货',showVideo:1,}})" class="av_oa">
                    <img src="https://s.cccgx.com/themes/v4/css/u/o3.png" class="av_tck">
                    <p>待收货</p>
                </a>
                <a href="javascript:;" @click="$router.push({path: '/weipingjia', query:{status:'待评价',showVideo:1,}})" class="av_oa">
                    <img src="https://s.cccgx.com/themes/v4/css/u/o4.png" class="av_tck">
                    <p>待评价</p>
                </a>
                <a href="javascript:;" @click="$router.push({path: '/shouhou', query:{showVideo:1,}})" class="av_oa">
                    <img src="https://s.cccgx.com/themes/v4/css/u/o5.png" class="av_tck">
                    <p>售后</p>
                </a>
                <div class="clear"></div>
            </div>
            <h2 class="ouh1">
                <em class="ou_tet">热销推荐</em>
                <p class="uo_line"></p>
            </h2>
            <div class="gdls">
                <!-- <div v-for="(item,index) in list" :key="index">
                    <router-link :to="{path:'/detail', query:{id:item.id,showVideo:1,title:item.title}}" target="_blank" class="dn_a">
                        <img :src="item.piclink" width="290" class="sbm">
                        <div class="h250">
                            <p class="gna pt10">{{item.title}}</p>
                            <p class="pt_g"></p>
                            <p class="gp_d mt5">
                                <i class="rmb left">¥</i>
                                <b class="xj left mr5">{{item.price}}</b>
                                <em class="cs_o">已售{{item.sale}}万件</em>
                            </p>
                        </div>
                        <span class="hot_tag"></span>
                    </router-link>
                </div> -->
                <dl class="gl" v-for="(item,index) in list" :key="index"  @mouseenter="mouseEnter($event)" @mouseleave="mouseLeave($event)">
                    <dt>
                        <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank">
                            <img :src="item.piclink" width="270" height="270" class="sbm" alt="">
                        </router-link>
                    </dt>
                    <!-- <dd class="simg">
                        <img src="https://s.cccgx.com/t/26x26/images/qu/10631/gallery/20210624034435_93941.jpg" width="26" height="26" class="ss_m">
                    </dd> -->
                    <dd>
                        <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank" class="gna pt10">
                            {{item.title}}
                        </router-link>
                        <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank" class="pt_g mt5">
                            <em class="p_tag">{{item.sub_title}}</em>
                        </router-link>
                    </dd>
                    <dd class="gp_d">
                        <i class="rmb left">¥</i>
                        <b class="xj left">{{item.price}}</b>
                        <em class="cs_o">已售{{item.sale}}件</em>
                    </dd>
                    <dd class="pt5">
                        <em class="i_hot">热销</em>
                        <!-- <em class="i_video">视频</em> -->
                        <i class="i_by">包邮</i>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>
<script>
import Public_user_home from "@/components/user/Index"
export default {
    components:{
        "public-home":Public_user_home
    },
    data() {
        return {
            activeName:'order',
            tabPosition: 'left',
            // userInfo:JSON.parse(window.localStorage.getItem("user")),
            userInfo:"",
            list:[]
        };
    },
    mounted(){
        this.getHotProduct();
        this.getUserInfo();
    },
    methods:{
        getHotProduct(){
            this.$api.getShop.getHotProduct({}).then(res=>{
                if(res.code == 200){
                    this.list = res.result.hot;
                }
            });
        },
        getUserInfo(){
            var params = {};
            params.id = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getUser.getUserInfo(params).then(res=>{
                if(res.code == 200){
                    this.userInfo = res.result;
                }
            })
        },
        //   鼠标移入
        mouseEnter($event){
            $event.currentTarget.className="gl hov";
        },
        //   鼠标移除
        mouseLeave($event){
            $event.currentTarget.className="gl";
        },
    }
};
</script>

<style scoped>
@import url('../../assets/css/user.css');
</style>


// WEBPACK FOOTER //
// src/components/user/Index.vue